export function readSendBlockedReason(
  data: Record<string, unknown> | undefined,
): string | null {
  if (!data || String(data.code || '') !== 'send_blocked') {
    return null;
  }
  const message = typeof data.message === 'string' ? data.message.trim() : '';
  return message || 'Отправка сообщений сейчас недоступна.';
}
